import inView from 'in-view';
import confetti from 'canvas-confetti';

// DOMContentLoaded event listener
document.addEventListener('DOMContentLoaded', () => {
    function showConfetti() {
        confetti({
            particleCount: 720,
            spread: 360,
            angle: -55,
            colors: ['#ff0000'],
            origin: { x: 0, y: 0 },
            resize: true,
        });
    }
    // On page load
    inView('.btn-gptw-badge')
        .once('enter', () => {
            showConfetti();
        });
});
